(function () {
  if (customElements.get('jd-caja-compra')) return;

  function escapar(texto) {
    var div = document.createElement('div');
    div.textContent = texto == null ? '' : String(texto);
    return div.innerHTML;
  }

  function hoyIso(zona) {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: zona || 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function normalizarFecha(texto) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(String(texto || '').trim());
    if (!m) return '';
    var mes = +m[2];
    var dia = +m[3];
    if (mes < 1 || mes > 12 || dia < 1 || dia > 31) return '';
    return m[1] + '-' + (mes < 10 ? '0' : '') + mes + '-' + (dia < 10 ? '0' : '') + dia;
  }

  // Shrine solo añade los interruptores de upsell marcados del cajón (Shipping Protection) al cargar la página.
  // Con «Add To Cart» (que abre el cajón con el interruptor a la vista), van en la misma petición si no están ya en el carrito.
  // El Shipping Protection entra salvo que la clienta lo haya quitado en este carrito (lo apunta jd-tienda.js en
  // jd_sin_proteccion con el token del carrito): el interruptor puede quedarse apagado sin que ella lo toque (27-sep).
  function proteccionQuitada() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    var token = m ? decodeURIComponent(m[1]).split('?')[0] : '';
    try { return !!token && localStorage.getItem('jd_sin_proteccion') === token; } catch (e) { return false; }
  }
  function upsellsMarcados() {
    var ids = [];
    document.querySelectorAll('cart-drawer-upsell[data-toggle="true"]').forEach(function (el) {
      var marcado = el.getAttribute('data-selected') === 'true' || (el.dataset.handle === 'shipping-protection' && !proteccionQuitada());
      var id = Number(el.dataset.id);
      if (marcado && id && ids.indexOf(id) === -1) ids.push(id);
    });
    if (!ids.length) return Promise.resolve([]);
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (carrito) {
        var dentro = (carrito.items || []).map(function (i) {
          return i.variant_id;
        });
        return ids.filter(function (id) {
          return dentro.indexOf(id) === -1;
        });
      })
      .catch(function () {
        return [];
      });
  }

  class JdCajaCompra extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[data-jd-form]');
      if (!this.form || this.iniciada) return;
      this.iniciada = true;
      this.casilla = this.querySelector('[data-jd-casilla]');
      this.campoId = this.form.querySelector('input[name="id"]');
      this.campoCantidad = this.form.querySelector('input[name="quantity"]');
      this.campoPlan = this.form.querySelector('input[name="selling_plan"]');
      this.error = this.querySelector('[data-jd-error]');
      this.anuncio = this.querySelector('[data-jd-anuncio]');
      this.modo = this.dataset.modo || 'unica';
      this.accion = null;

      this.addEventListener('change', (e) => {
        if (e.target === this.casilla) {
          this.cambiarModo(this.casilla.checked ? 'suscripcion' : 'unica');
          this.anunciar();
        } else if (e.target.matches('[data-jd-tarjeta] input[type="radio"]')) {
          this.actualizar();
          this.anunciar();
        }
      });
      this.form.addEventListener('click', (e) => {
        var boton = e.target.closest('button[data-jd-accion]');
        if (boton) this.accion = boton.dataset.jdAccion;
      });
      this.form.addEventListener('submit', (e) => this.enviar(e));
      window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        this.cargando(false);
        this.quitarRetorno();
        if (this.casilla) this.modo = this.casilla.checked ? 'suscripcion' : 'unica';
        this.actualizar();
      });
      this.actualizar();
    }

    anunciar() {
      if (!this.anuncio) return;
      var plantilla = this.anuncio.dataset['jdAnuncio' + (this.modo === 'suscripcion' ? 'Suscripcion' : 'Unica')] || '';
      var tokens = this.tokensActivos || {};
      var texto = plantilla.replace(/\[([a-z_]+)\]/g, function (todo, clave) {
        return Object.prototype.hasOwnProperty.call(tokens, clave) ? escapar(tokens[clave]) : '';
      });
      var div = document.createElement('div');
      div.innerHTML = texto;
      this.anuncio.textContent = div.textContent.replace(/\s+/g, ' ').trim();
    }

    quitarRetorno() {
      var campo = this.form.querySelector('input[data-jd-retorno]');
      if (campo) campo.remove();
    }

    grupo(modo) {
      return this.querySelector('[data-jd-grupo="' + modo + '"]');
    }

    tarjetaActiva() {
      var grupo = this.grupo(this.modo);
      if (!grupo) return null;
      var marcada = grupo.querySelector('input[type="radio"]:checked');
      if (marcada) return marcada.closest('[data-jd-tarjeta]');
      var primera = grupo.querySelector('[data-jd-tarjeta]');
      if (primera) primera.querySelector('input[type="radio"]').checked = true;
      return primera;
    }

    cambiarModo(modo) {
      var destino = this.grupo(modo);
      if (!destino) {
        if (this.casilla) this.casilla.checked = this.modo === 'suscripcion';
        return;
      }
      var anterior = this.tarjetaActiva();
      this.modo = modo;
      if (anterior) {
        var gemela = destino.querySelector(
          '[data-jd-tarjeta][data-variante="' + anterior.dataset.variante + '"][data-cantidad="' + anterior.dataset.cantidad + '"]'
        );
        if (gemela) gemela.querySelector('input[type="radio"]').checked = true;
      }
      this.actualizar();
    }

    plazo() {
      var d = this.dataset;
      var min = d.plazoMin;
      var max = d.plazoMax;
      var hasta = normalizarFecha(d.tempHasta);
      if (hasta && +d.tempMax > 0 && hoyIso(d.zona) <= hasta) {
        min = d.tempMin;
        max = d.tempMax;
      }
      return min + '-' + max;
    }

    actualizar() {
      var modo = this.modo;
      this.querySelectorAll('[data-jd-grupo]').forEach(function (g) {
        g.hidden = g.dataset.jdGrupo !== modo;
      });

      var activa = this.tarjetaActiva();
      this.querySelectorAll('[data-jd-tarjeta]').forEach(function (t) {
        t.classList.toggle('is-activa', t === activa);
      });
      if (!activa) return;

      this.campoId.value = activa.dataset.variante;
      this.campoCantidad.value = activa.dataset.cantidad || '1';
      this.campoPlan.value = modo === 'suscripcion' ? activa.dataset.plan || '' : '';

      var tokens = {};
      try {
        tokens = JSON.parse(activa.dataset.tokens || '{}');
      } catch (e) {}
      tokens.plazo = this.plazo();
      this.tokensActivos = tokens;

      this.querySelectorAll('[data-jd-plantilla]').forEach(function (el) {
        el.innerHTML = el.dataset.jdPlantilla.replace(/\[([a-z_]+)\]/g, function (todo, clave) {
          return Object.prototype.hasOwnProperty.call(tokens, clave) ? escapar(tokens[clave]) : todo;
        });
      });
      this.querySelectorAll('[data-jd-mostrar]').forEach(function (el) {
        var m = el.dataset.jdMostrar;
        el.hidden = !(m === 'siempre' || m === modo);
      });

      this.dispatchEvent(
        new CustomEvent('jd:caja:cambio', {
          bubbles: true,
          detail: {
            modo: modo,
            variante: Number(activa.dataset.variante),
            cantidad: Number(activa.dataset.cantidad || 1),
            plan: modo === 'suscripcion' ? activa.dataset.plan : null
          }
        })
      );
    }

    mostrarError(mensaje) {
      if (!this.error) return;
      this.error.textContent = mensaje || '';
      this.error.hidden = !mensaje;
    }

    cargando(activo) {
      this.form.querySelectorAll('button[type="submit"]').forEach(function (b) {
        b.disabled = activo;
        b.classList.toggle('is-cargando', activo);
        b.setAttribute('aria-busy', activo ? 'true' : 'false');
      });
    }

    enviar(e) {
      var accion = (e.submitter && e.submitter.dataset.jdAccion) || this.accion || 'anadir';
      this.accion = null;
      if (accion === 'anadir' && this.dataset.modoCarrito === 'pagina') return;
      e.preventDefault();
      this.mostrarError('');
      this.cargando(true);

      var linea = { id: Number(this.campoId.value), quantity: Number(this.campoCantidad.value || 1) };
      if (this.campoPlan.value) linea.selling_plan = Number(this.campoPlan.value);
      var datos = {};

      var cajon = accion === 'anadir' ? document.querySelector('cart-drawer') : null;
      if (cajon && typeof cajon.getSectionsToRender === 'function') {
        datos.sections = cajon
          .getSectionsToRender()
          .map(function (s) {
            return s.id;
          })
          .join(',');
        datos.sections_url = window.location.pathname;
      }

      var caja = this;
      (accion === 'anadir' ? upsellsMarcados() : Promise.resolve([]))
        .then(function (extras) {
          datos.items = [linea].concat(
            extras.map(function (id) {
              return { id: id, quantity: 1 };
            })
          );
          return fetch(caja.dataset.urlAnadir, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(datos)
          });
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (respuesta) {
          if (respuesta.status) {
            caja.mostrarError(respuesta.description || respuesta.message);
            caja.cargando(false);
            return;
          }
          document.dispatchEvent(
            new CustomEvent('jd:carrito:anadido', { detail: { respuesta: respuesta, accion: accion, caja: caja } })
          );
          if (accion === 'ya') {
            window.location.href = caja.dataset.urlPago;
            return;
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'jd-caja-compra',
              productVariantId: Number(caja.campoId.value),
              cartData: respuesta
            });
          }
          if (cajon && typeof cajon.renderContents === 'function' && respuesta.sections) {
            cajon.classList.remove('is-empty');
            cajon.renderContents(respuesta);
            caja.cargando(false);
            return;
          }
          window.location.href = caja.dataset.urlCarrito;
        })
        .catch(function () {
          caja.cargando(false);
          caja.quitarRetorno();
          if (accion === 'ya') {
            var retorno = document.createElement('input');
            retorno.type = 'hidden';
            retorno.name = 'return_to';
            retorno.value = caja.dataset.urlPago;
            retorno.setAttribute('data-jd-retorno', '');
            caja.form.appendChild(retorno);
          }
          caja.form.submit();
        });
    }
  }

  customElements.define('jd-caja-compra', JdCajaCompra);

  // Galería con Splide, la librería de carruseles de Shrine (va en secondary.js, que carga antes): arrastre con inercia, bucle y miniaturas sincronizadas.
  class JdGaleria extends HTMLElement {
    connectedCallback() {
      if (this._jd) return;
      var principal = this.querySelector('[data-jd-principal]');
      var miniaturas = this.querySelector('[data-jd-miniaturas]');
      if (!principal) return;
      if (!window.Splide) {
        // Sin Splide queda la fila deslizable: sus imágenes diferidas se cargan ya.
        principal.querySelectorAll('img[data-jd-diferida]').forEach(function (img) {
          if (img.dataset.jdSrcset) img.srcset = img.dataset.jdSrcset;
          if (img.dataset.jdSrc) img.src = img.dataset.jdSrc;
          img.removeAttribute('data-jd-diferida');
        });
        return;
      }
      this._jd = true;
      // Antes de medir: fuera la fila de reserva sin JavaScript, que cambia los huecos y esconde las miniaturas.
      this.classList.add('is-montando');
      var sinMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var primera = principal.querySelector('img:not([data-jd-diferida])');
      var grande = new window.Splide(principal, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '16px',
        arrows: false,
        pagination: false,
        speed: sinMovimiento ? 0 : 450,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        drag: true,
        flickPower: 600,
        flickMaxPages: 1,
        dragMinThreshold: { mouse: 4, touch: 10 },
        keyboard: 'focused',
        mediaQuery: 'min',
        breakpoints: { 750: { gap: '24px' } }
      });
      var fila = null;
      if (miniaturas) {
        fila = new window.Splide(miniaturas, {
          type: 'slide',
          isNavigation: true,
          fixedWidth: 60,
          fixedHeight: 60,
          gap: '8px',
          padding: { left: '16px', right: '16px' },
          focus: 0,
          trimSpace: 'move',
          pagination: false,
          arrows: false,
          speed: sinMovimiento ? 0 : 400,
          dragMinThreshold: { mouse: 4, touch: 10 },
          mediaQuery: 'min',
          breakpoints: { 750: { fixedWidth: 120, fixedHeight: 120, gap: '16px', padding: { left: '20px', right: '20px' } } }
        });
        grande.sync(fila);
      }
      grande.on('move', function () {
        principal.querySelectorAll('video').forEach(function (v) {
          v.pause();
        });
      });
      grande.mount();
      if (fila) {
        fila.mount();
        // Las flechas de la fila mueven la imagen grande, y la fila la sigue, como en Koriderm.
        var ant = miniaturas.querySelector('[data-jd-anterior]');
        var sig = miniaturas.querySelector('[data-jd-siguiente]');
        if (ant) ant.addEventListener('click', function () { grande.go('<'); });
        if (sig) sig.addEventListener('click', function () { grande.go('>'); });
      }
      this.splide = grande;

      // Las imágenes siguientes llegan sin src (data-jd-src), para no quitarle red a la primera.
      // Se cargan cuando la primera ya está, al mover la galería o, como tarde, al terminar la página; también las copias del bucle.
      var cargadas = false;
      var cargar = function () {
        if (cargadas) return;
        cargadas = true;
        principal.querySelectorAll('img[data-jd-diferida]').forEach(function (img) {
          if (img.dataset.jdSrcset) img.srcset = img.dataset.jdSrcset;
          if (img.dataset.jdSrc) img.src = img.dataset.jdSrc;
          img.loading = 'eager';
          img.removeAttribute('data-jd-diferida');
        });
      };
      grande.on('move drag', cargar);
      if (!primera || primera.complete) setTimeout(cargar, 300);
      else {
        primera.addEventListener('load', function () { setTimeout(cargar, 300); });
        primera.addEventListener('error', cargar);
      }
      if (document.readyState === 'complete') setTimeout(cargar, 300);
      else window.addEventListener('load', cargar);
    }

    disconnectedCallback() {
      if (this.splide) {
        this.splide.destroy();
        this.splide = null;
        this._jd = false;
      }
    }
  }

  if (!customElements.get('jd-galeria')) customElements.define('jd-galeria', JdGaleria);
})();
